import { useState } from "react";
import { HERITAGE_CARE_TIPS } from "../lib/fieldSchemas";
import { ChevronDown, Shield } from "lucide-react";

/**
 * Educational-only Heritage Item Care panel.
 * Not part of any workflow. Purely informative.
 */
export function HeritageCareCard({ defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="card-heritage" data-testid="heritage-care-card">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 text-left"
        aria-expanded={open}
        data-testid="heritage-care-toggle"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[var(--oih-parchment)] flex items-center justify-center">
            <Shield size={18} className="text-navy" />
          </div>
          <div>
            <div className="font-display text-xl text-navy leading-tight">Caring for Your Heritage Item</div>
            <div className="text-sm text-ink-soft">Simple guidance to help preserve family artifacts for future generations.</div>
          </div>
        </div>
        <ChevronDown size={20} className={`text-muted-h transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {HERITAGE_CARE_TIPS.map((tip) => (
            <div key={tip.title} className="border-l-2 border-[var(--oih-gold)] pl-3">
              <div className="font-display text-lg text-navy leading-snug">{tip.title}</div>
              <p className="text-sm text-ink-soft mt-1 leading-relaxed">{tip.body}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
